<script>
const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
export default {
  methods: {
    // Crea un rango de números, similar a lo que hace python
    $_generalUtils_range (start, end) {
      return Array(end - start + 1).fill().map((_, i) => i + start)
    },
    /* Inicio Sección fechas */
    // Se hizo necesario crear el formatting por los problemas que presenta js con las fechas al pasarla
    // a formato UTC, ejemplo el clásico detalle que resta un día a la fecha local
    $_generalUtils_YYYMMDDFormattingDate (date = new Date()) {
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      // Aca solucionamos el otro problema de js que parte con el mes en 0
      let currentMonth = date.getMonth() + 1
      let month = currentMonth < 10 ? '0' + currentMonth : currentMonth
      let year = date.getFullYear()
      return `${year}${month}${day}`
    },
    $_generalUtils_getFirstMonthDayOnDate (date = new Date()) {
      let formattedDate = this.$_generalUtils_YYYMMDDFormattingDate(date)
      return formattedDate.slice(0, 6) + '01'
    },
    $_generalUtils_getFirstYearDayOnDate (year = new Date().getFullYear()) {
      if (typeof year !== 'number') {
        year = new Date().getFullYear()
      }
      return year.toString() + '0101'
    },
    $_generalUtils_getLastDayOfMonthOnDate (year, month) {
      let date = {}
      if (typeof year === 'number' && typeof month === 'number') {
        date = new Date(year, month, 0)
      } else {
        const currentYear = new Date().currentYear
        date = new Date(currentYear, 12, 0)
      }
      return this.$_generalUtils_YYYMMDDFormattingDate(date)
    },
    $_generalUtils_getMonths (language = 'english') {
      if (language === 'english') {
        return months
      } else {
        throw new Error('Idioma no soportado')
      }
    },
    $_generalUtils_monthsMapper (objectToMap, dimension, totalColumnFlag = false) {
      if ((typeof objectToMap) === 'object') {
        /* Obtiene todos los atributos del objeto para comparar con el array de meses, si no hace match con ninguno quiere decir que no era siquiera un objeto de meses */
        const objectKeys = Object.keys(objectToMap)
        if (months.filter(x => objectKeys.includes(x)).length > 0 &&
            objectKeys.includes(dimension.dim_value) &&
            objectKeys.includes(dimension.dim_key)) {
          let mappedObject = {
            [dimension.dim_key]: objectToMap[dimension.dim_key],
            [dimension.dim_value]: objectToMap[dimension.dim_value],
            'Enero': objectToMap.January ? objectToMap.January : 0,
            'Febrero': objectToMap.February ? objectToMap.February : 0,
            'Marzo': objectToMap.March ? objectToMap.March : 0,
            'Abril': objectToMap.April ? objectToMap.April : 0,
            'Mayo': objectToMap.May ? objectToMap.May : 0,
            'Junio': objectToMap.June ? objectToMap.June : 0,
            'Julio': objectToMap.July ? objectToMap.July : 0,
            'Augosto': objectToMap.August ? objectToMap.August : 0,
            'Septiembre': objectToMap.September ? objectToMap.September : 0,
            'Octubre': objectToMap.October ? objectToMap.October : 0,
            'Noviembre': objectToMap.November ? objectToMap.November : 0,
            'Deciembre': objectToMap.December ? objectToMap.December : 0
          }
          /* Solo en caso de que se requiera crear un columna que tenga la suma de todas las otras columnas que sean de tipo number */
          if (totalColumnFlag) {
            let totalColumn = 0
            for (let prop in objectToMap) {
              if (objectToMap.hasOwnProperty(prop) && typeof objectToMap[prop] === 'number') {
                totalColumn += objectToMap[prop]
              }
            }
            mappedObject = {...mappedObject, 'Total': totalColumn}
          }
          return mappedObject
        } else {
          throw Error('Objeto no corresponde a un objeto de meses')
        }
      } else {
        throw new Error('Parámetro no es un objeto')
      }
    },
    /* Fin Sección fechas */
    /* Sección Objetos   */
    $_generalUtils_deepJsonCopy (Object) {
      return JSON.parse(JSON.stringify(Object))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/GeneralUtils.vue